import type { GameLevel } from '../../types/game';
import { LEVEL_001 } from './level-001';
import { LEVEL_002 } from './level-002';
import { LEVEL_003 } from './level-003';

export const LEVELS: GameLevel[] = [LEVEL_001, LEVEL_002, LEVEL_003];
